import * as types from '../../types'
import app from '../../../api/app'

const state = {
  loaded: false,
  formLoaded: false,
  flowLoaded: false,
  dataLoaded: false,
  setLoaded: false,
  config: {},
}

const actions = {
  getFormConfig({commit}, param) {
    return new Promise((resolve, reject) => {
      app.formConfig(param.moduleId, param.appId).then((data) => {
        commit(types.GET_FORM_CONFIG, data.result)
        commit(types.GET_FORM_CONFIG_LOADED, true)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })

  },
  setFormLoaded({commit}, loaded) {
    commit(types.SET_FORM_LOADED, loaded)
  },
  setFlowLoaded({commit}, loaded) {
    commit(types.SET_FLOW_LOADED, loaded)
  },
  setDataLoaded({commit}, loaded) {
    commit(types.SET_DATA_LOADED, loaded)
  },
  setSetLoaded({commit}, loaded) {
    commit(types.SET_SET_LOADED, loaded)
  },
  setFormConfigLoaded({commit}, loaded) {
    commit(types.GET_FORM_CONFIG_LOADED, loaded)
  },
  clearLoaded({commit}) {
    commit('Clear_Loaded')
  }
}

const getters = {}

const mutations = {
  Clear_Loaded(state) {
    state.loaded = false,
    state.formLoaded = false,
    state.flowLoaded = false,
    state.dataLoaded = false,
    state.setLoaded = false,
    state.config = {};
  },

  [types.SET_FORM_LOADED](state, loaded) {
    state.formLoaded = loaded;
  },
  [types.SET_FLOW_LOADED](state, loaded) {
    state.flowLoaded = loaded;
  },
  [types.SET_DATA_LOADED](state, loaded) {
    state.dataLoaded = loaded;
  },
  [types.SET_SET_LOADED](state, loaded) {
    state.setLoaded = loaded;
  },
  [types.GET_FORM_CONFIG_LOADED](state, loaded) {
    state.loaded = loaded;
  },
  [types.GET_FORM_CONFIG](state, result) {
    state.config = result;
  }
}


export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/common/vuex/modules/app/formConfig.js